import Bugsnag from '@bugsnag/js'
import CustomError from '@/errors/CustomError'

const NotifyError = (error: Error) => {
  if (error instanceof CustomError) {
    return
  }

  Bugsnag.notify(error)
}

export default NotifyError
